import React from 'react';
// @ts-ignore
import styles from './LaboratoryRequestCreateWizardStepWrapper.module.scss';
import ScrollContainer from '../../../Base/Components/ScrollContainer';

interface Props {
	children: React.ReactNode | React.ReactNode[];
}

const LaboratoryRequestCreateWizardStepWrapper: React.FC<Props> = ({
	children,
}) => {
	return (
		<div className={styles.wrapper}>
			<ScrollContainer>{children}</ScrollContainer>
		</div>
	);
};

export default LaboratoryRequestCreateWizardStepWrapper;
